<template>
	<App title="cluster Details">
		<div class="w-100 position-relative">
			<!-- cluster Information Section -->
			<Block class="border-top border-secondary border-2 col-md-10 mx-auto mb-4">
				<template #header>
					<h3 class="block-title">cluster Information</h3>
					<a
						
						:href="route('cluster.page.update', { cluster: cluster.id })"
						class="btn btn-outline-secondary btn-sm"
						:disabled="clusterLoading"
						>
						<i class="bi bi-pencil me-1"></i>
						{{ cluster.manager ? 'Change' : 'Assign' }} Manager
				</a>

				</template>

				<div class="card border-0">
					<div class="card-body p-4">
						<div class="row g-4">
							<!-- cluster Details -->
							<div class="col-12 col-md-6">
								<div class="border-start border-secondary border-3 ps-3">
									<h5 class="fw-bold text-dark mb-3">
										<i class="bi bi-map-fill text-secondary me-2"></i>
										{{ cluster.name || 'Loading...' }}
									</h5>
									<div class="row g-2">
										<div class="col-12">
											<span class="text-muted small">
												<i class="bi bi-geo-alt me-1"></i>Location:
											</span>
											<span class="fw-medium ms-2">{{ cluster.location || '-' }}</span>
										</div>
										<div class="col-12">
											<span class="text-muted small">
												<i class="bi bi-building me-1"></i>State:
											</span>
											<span class="fw-medium ms-2">{{ cluster.zone?.state?.name || '-' }}</span>
										</div>
									</div>
								</div>
							</div>

							<!-- Manager Info -->
							<div class="col-12 col-md-6">
								<div class="d-flex align-items-center justify-content-between">
									<div>
										<h6 class="text-muted mb-1">
											<i class="bi bi-person-badge me-1"></i>cluster Manager
										</h6>
										<p class="mb-0 fw-medium">
											{{ cluster.manager?.fullname || 'Unassigned' }}
											<small class="text-muted d-block" v-if="cluster.manager?.email">
												{{ cluster.manager.email }}
											</small>
										</p>
									</div>
									
								</div>
							</div>
						</div>
					</div>
				</div>
			</Block>

			<!-- Clusters Section -->
			<Block class="border-top border-secondary border-2 col-md-10 mx-auto mb-4">
				<template #header>
					<div class="d-flex align-items-center justify-content-between w-100">
						<h3 class="block-title mb-0">Clusters in this cluster</h3>
						<a 
							type="button" 
							class="btn bg-secondary text-light btn-sm ms-auto"
							:href="route('station.page.create',{cluster:cluster.id})"
						>
							<i class="bi bi-plus-circle me-1"></i>Create Station
                    </a>
					</div>
				</template>

				<div class="card border-0">
					<div class="card-body p-0">
						
						<!-- Clusters Table -->
						<div class="table-responsive">
							<Datatable :options="options" />
						</div>
					</div>
				</div>
			</Block>

			<!-- Audit Section -->
			<Block class="border-top border-secondary border-2 col-md-10 mx-auto">
				<template #header>
					<h3 class="block-title">Audit Information</h3>
				</template>

				<div class="card border-0">
					<div class="card-body p-4">
						<div class="row g-3">
							<div class="col-12 col-md-4">
								<span class="text-muted small d-block">
									<i class="bi bi-person-plus me-1"></i>Created By
								</span>
								<span class="fw-medium">{{ cluster.created_by || '-' }}</span>
							</div>
							<div class="col-12 col-md-4">
								<span class="text-muted small d-block">
									<i class="bi bi-calendar-plus me-1"></i>Created At
								</span>
								<span class="fw-medium">{{ formatDate(cluster.created_at) }}</span>
							</div>
							<div class="col-12 col-md-4">
								<span class="text-muted small d-block">
									<i class="bi bi-clock-history me-1"></i>Last Updated
								</span>
								<span class="fw-medium">{{ formatDate(cluster.updated_at) }}</span>
							</div>
						</div>
					</div>
				</div>
			</Block>
		</div>

	

		<!-- Notification Area -->
		<div class="mt-9 position-absolute top-0 end-0">
			<NotivueKeyboard v-slot="{ containersTabIndex }">
				<Notivue v-slot="item" :containersTabIndex="containersTabIndex">
					<AppNotification :item="item" />
				</Notivue>
			</NotivueKeyboard>
		</div>
	</App>
</template>

<script lang="ts">
import type cluster from '@/models/cluster'
import { useConfirm } from '@/libs/useConfirm.ts'
import AppNotification from '@/vue/components/AppNotification.vue'
import Block from '@/vue/components/Block.vue'
import Button from '@/vue/components/Button.vue'
import Form from '@/vue/components/Form.vue'
import InputField from '@/vue/components/InputField.vue'
import SelectField from '@/vue/components/SelectField.vue'
import App from '@/vue/templates/App.vue'
import { ButtonLabel } from '@/vue/utils/Button'
import $ from 'jquery'
import { materialTheme, Notivue, NotivueKeyboard, push } from 'notivue'
import { Options as Select2Options } from 'select2'
import Swal from 'sweetalert2'
import { Link } from '@inertiajs/vue3'
import Datatable from '@/vue/components/Datatable.vue'
import { CellRender, Column } from '@/vue/utils/Datatable'
import { Component, Ref, toNative, Vue, Prop } from 'vue-facing-decorator'



interface ClusterData {
	id?: string
	name: string
	location: string
	manager?: string
	manager_name?: string
	manager_email?: string
	created_at?: string
}

@Component({
	components: {
		App,
		Block,
		Form,
		InputField,
		SelectField,
		Button,
		Notivue,
		AppNotification,
		NotivueKeyboard,
		Datatable,
		Link
	},
})
class Single extends Vue {
	confirm = useConfirm().confirm
	materialTheme = materialTheme

	// cluster data (from Inertia props)

	
	clusterLoading = false

	// Clusters data
	clusters: ClusterData[] = []
	clustersLoading = false
	clustersError = false

	// Manager assignment
	managerData = {
		manager: '',
	}
	managerLoading = false
	managerDone = false

	@Ref('managerForm')
	readonly managerForm!: InstanceType<typeof Form>
    
    @Prop({ type: Object })
    readonly cluster!: cluster

	get buttons() {
		let buttons: any[] = []
		buttons.push('refresh')
		

		return buttons
	}


	get columns() {
		let columns: any[] = []

	
	
		columns.push({
			data: 'title',
			title: 'Station Name',
		})
		columns.push({
			data: 'managers.0.fullname',
			title: 'Station Manager',
		})
		columns.push({
			data: 'managers.0.phone',
			title: 'Phone number',
		})
		columns.push({
			data: 'created_at',
			title: 'Registered',
			render: CellRender.date(),
			orderable: true,
			name: 'created_at',
		})

		//columns.push(Column.actions(this.$gate))

		return columns
	}

	get options() {
		return {
			ajax: {
				url: this.route('cluster.ajax.table.stations',{ cluster: this.cluster.id }),
				method: 'POST',
			},
			buttons: this.buttons,
			columns: this.columns,
		}
	}

	// Computed properties
	get manager_options(): Select2Options {
		return {
			placeholder: 'Select Warehouse Manager',
			minimumResultsForSearch: Infinity,
			ajax: {
			method: 'get',
			url: this.route('admin.ajax.select.admin'),
			},
			// Pre-populate with the current manager data
			data: this.cluster.manager ? [{
			id: this.cluster.manager.id,
			text: `${this.cluster.manager.fullname} (${this.cluster.manager.email})`,
			fullname: this.cluster.manager.fullname,
			email: this.cluster.manager.email
			
			}] : [],
			//@ts-ignore
			templateResult: ({ id, fullname, email, text }) => 
			(id ? $(`<span>${fullname} &nbsp; (${email})</span>`) : text),
			//@ts-ignore
			templateSelection: ({ id, fullname, email, text }) => 
			(id ? $(`<span>${fullname} &nbsp; (${email})</span>`) : text),
		}
	}

	get managerLabels(): ButtonLabel {
		return {
			normal: this.cluster.manager ? 'Change Manager' : 'Assign Manager',
			loading: 'Saving...',
			done: 'Saved',
		}
	}

	// Lifecycle
	async mounted() {
		//await this.loadClusters()
	}

	// Methods
	

	openManagerModal() {
		this.managerData.manager = this.cluster.manager?.id || ''
		$('#managerModal').modal('show')
	}

	navigateToCreateCluster() {
		// Navigate to cluster creation page with prefilled data
		this.$inertia.visit(this.route('cluster.page.create'), {
			data: {
				// Pass cluster data as query parameters to prefill the form
				prefill_state: this.cluster.zone?.state?.id,
				prefill_state_name: this.cluster.zone?.state?.name,
				prefill_cluster: this.cluster.id,
				prefill_cluster_name: this.cluster.name,
				prefill_location: this.cluster.location,
				prefill_designation: this.cluster.designation?.id,
				prefill_designation_name: this.cluster.designation?.name,
			}
		})
	}


	formatDate(dateString?: string): string {
		if (!dateString) return '-'
		return new Date(dateString).toLocaleDateString('en-US', {
			year: 'numeric',
			month: 'short',
			day: 'numeric',
			hour: '2-digit',
			minute: '2-digit',
		})
	}
}

export default toNative(Single)
</script>

<style scoped>
.border-start {
	border-left-width: 3px !important;
}

.btn-group-sm > .btn {
	padding: 0.25rem 0.5rem;
	font-size: 0.875rem;
}

.table > :not(caption) > * > * {
	padding: 0.75rem 0.5rem;
}

.modal-lg {
	max-width: 800px;
}

.alert-light {
	background-color: #f8f9fa;
	border-color: #dee2e6;
}
</style>